// Product ID to single Variant ID mapping
let tangent_selected_product_map;

let default_addToCartText = "Add To Cart";
const default_addedToCartText = "Added to Cart!";
const default_add_all_to_cart_text = "Add All to Cart"
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No products found. Please retry!";

// Tab title mapping based on tags
const tabs_title_mapping={
  section_basic:"Basics",
  section_essential:"Essentials",
  section_works:"Works"
}

const TAB_EXCLUDED_SECTIONS = [
    "section_selfie"
];

let sections_add_to_cart_map={};
let tangent_client_domain_currency;
let tangentRecommendedProducts=[];

const tangent_client_domain_url = window.location.origin;

// Tabs for recommended and routine sections
const tangent_custom_tabs = document.querySelector("#tangent_product_custom_tabs"); 
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 

const tangent_default_selfie_image_url="";
const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

const selectElement = (sel, par) => (par || document).querySelector(sel),
    elPopup = selectElement("#tangent-popup-msg");
    
const products_region_map = {
        final_full_glow: {
            acne: 8015954673834,
            wrinkles: 7803775025322,
            dark_spots: 7803775025322,
            rosacea: 7791720759466,
            dark_circles: 3745912291412
        },
        final_glass_skin: {
            acne: 4360103493716,
            wrinkles: 3610310180948,
            dark_spots: 4360103493716,
            rosacea: 6898198347946,
            dark_circles: 3745912291412
        },
        final_barrier_repair: {
            acne: 8015954673834,
            wrinkles: 7803775025322,
            dark_spots: 7803775025322,
            rosacea: 7791720759466,
            dark_circles: 3745912291412
        }
    },
    area_mapping = {
        forehead: ["rosacea_forehead", "dark_spots_forehead", "wrinkles_forehead", "acne_forehead"],
        left_cheek: ["rosacea_left_cheek", "dark_spots_left_cheek", "acne_left_cheek"],
        right_cheek: ["rosacea_right_cheek", "dark_spots_right_cheek", "acne_right_cheek"],
        left_eye: ["rosacea_left_eye", "dark_spots_left_eye", "acne_left_eye"],
        right_eye: ["rosacea_right_eye", "dark_spots_right_eye", "acne_right_eye"],
        left_jaw: ["dark_spots_left_jaw", "acne_left_jaw"],
        right_jaw: ["dark_spots_right_jaw", "acne_right_jaw"],
        chin: ["dark_spots_chin", "acne_chin"],
        nose: ["rosacea_nose", "dark_spots_nose", "acne_nose"],
        right_eye_under: ["wrinkles_right_eye_under", "dark_circles_right_eye_under"],
        right_eye_corner: ["wrinkles_right_eye_corner"],
        left_eye_under: ["wrinkles_left_eye_under", "dark_circles_left_eye_under"],
        left_eye_corner: ["wrinkles_left_eye_corner"],
        right_lip_corner: ["wrinkles_right_lip_corner"],
        left_lip_corner: ["wrinkles_left_lip_corner"]
    };

let condition_msg_map = [],
    final_selected_regions = [],
    tangent_all_tags;
    
const url = new URL(window.location.href),
    imgid = url.searchParams.get("id"),
    resp_id = url.searchParams.get("resp_id"),
    currentScriptUrl = document.currentScript.src,
    tangentAssetsBase = "https://cdn.shopify.com/s/files/1/0838/0117/8412/files/";

async function getResponseId() {
  return new URL(window.location.href).searchParams.get("resp_id");
}

function onLoadFunction() {
    getResponseId().then(tangent_response_id => showRecommendation(tangent_response_id)).catch(err => {
        console.log("Error: " + err)
    })
}

document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", event => {
    onLoadFunction()
}) : onLoadFunction();

async function showRecommendation(tangent_response_id) {
    if (!tangent_response_id) return;

    toggle_loader_view(true);
    changeLoadingText("Fetching your results...");

    const checkout_url =
        `https://service.tangent.ai/shopify/get-checkout-products` +
        `?resp_id=${tangent_response_id}` +
        `&self_serve=true&multiple_variants=true`;

    try {
        const response = await fetch(checkout_url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        handleRecommendationData(data);

    } catch (error) {
        console.error("Error in server call:", error);

        toggle_loader_view(false);

        show_selfie_popupmessage(
        "Something went wrong, please check your internet connection!",
        "tangent-popup-msg"
        );
    }
}

function handleRecommendationData(response) {
    tangentRecommendedProducts = response.products; 
    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    // Setting selfie / default image
    handleSelfieDisplay(response);
    tangent_all_tags = response.tags;

    // Process tags
    if (tangent_all_tags.length > 0) {
        processTagsAndDisplaySelfie();
    }
  
    const tangent_product_sections = response.product_sections;
    const tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);
    }    

    setTabOpen(response.tags);
    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections, response.tags);
    }

    if (tangentRecommendedProducts.length > 0) {
        setProductsToView(tangentRecommendedProducts, tangent_product_sections, response.selected_variants);
        enableButtonListener();
        loadElementsOnResponseData();        
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }
}

function setProductsToView(products, sections, selected_variants) {
    tangent_selected_product_map = {};

    // Create product lookup map
    const productMap = Object.fromEntries(
        products.map((product, index) => [
            String(product.id),
            { product, index }
        ])
    );

    Object.entries(sections).forEach(([section, productIds]) => {
        const grid = document.getElementById(`${section}_product_grid`);

        if (!grid) return;

        const fragment = document.createDocumentFragment();

        productIds.forEach(id => {
            const item = productMap[String(id)];

            if (!item) return;

            const { product, index } = item;

            const variant = getSelectedVariant(product, selected_variants[product.id]);
                
            // Track selected product variant
            tangent_selected_product_map[product.id] = extractVariantId(variant.id);

            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = getProductHTML(
                product,
                index,
                variant,
                section,
                sections
            );

            fragment.append(...tempDiv.childNodes);
        });

        grid.appendChild(fragment);
    });
}

function getProductHTML(product, index, variant, section, sections) {
    const variantImageUrl = getVariantImage(variant, product);

    const variantProductUrl =
        `${tangent_client_domain_url}/products/${product.handle}?variant=${variant.id}`;

    const variantTitle =
        variant.title === "Default Title" ? "" : variant.title;

    const isAvailable = isProductAvailable(product, variant);

    if (isAvailable) {
        updateSectionAllToCartLink(
            sections,
            product.id,
            tangent_selected_product_map[product.id],
            section,
            variant
        );
    }

    return renderProductCard({
        product,
        index,
        variant,
        variantImageUrl,
        variantProductUrl,
        variantTitle,
        isAvailable
    });
}

function extractVariantId(variantId) {
  return variantId.replace("gid://shopify/ProductVariant/", "");
}

function renderProductCard({
    product,
    index,
    variant,
    variantImageUrl,
    variantProductUrl,
    variantTitle,
    isAvailable
}) {
    const buttonText = isAvailable
        ? default_addToCartText
        : out_of_stock_text;
    const variantId = extractVariantId(variant.id);
    const buttonClass = isAvailable
        ? ""
        : "disable-button";

    return `
        <div class="tangent-product-card">
            <div><a
                class="tangent-text-link"
                target="_blank"
                href="${variantProductUrl}"
            >
                <img
                    src="${variantImageUrl}"
                    class="tangent_product_image"
                    alt="${product.title}"
                >
            </a>
            </div>
            <div>
                <a
                    class="tangent-text-link"
                    target="_blank"
                    href="${variantProductUrl}"
                >
                    <p class="tangent-product-title tangent_product_title_text">
                        ${product.title}
                    </p>
                </a>
                
                <p
                    class="tangent_product_price_text"
                >
                    ${tangent_client_domain_currency}${variant.price}
                </p>
               
                <button
                    type="button"
                    class="tangent-product-add-btn-wrapper btn btn--secondary btn--solid-border btn--small btn--advanced btn--submit product__submit__add btn--top ${buttonClass}"
                    id="${variantId}"
                    ${!isAvailable ? "disabled" : ""}
                >
                    ${buttonText}
                </button>
            </div>
        </div>
    `;
}

function isProductAvailable(product, variant){
  // Check if the product is active
  if (product.status !== "active") {
      return false;
  }
  return variant.available_for_sale;
}



function processTagsAndDisplaySelfie() {

    const matchedTags = Object.values(area_mapping)
        .flatMap(tags => tags.filter(tag => tangent_all_tags.includes(tag)));

    final_selected_regions = [...new Set(matchedTags)];

    checkForProduct();

    if (!condition_msg_map || !condition_msg_map.length) {
        if (!skip_selfie) {
            show_selfie_popupmessage(
                "Your selfie + skin is looking clear today! Here are the best products for your current skin-state. Feel like we missed something? Try taking your selfie again",
                "tangent-popup-msg-skip"
            );
        }

        toggle_loader_view(false);
        return;
    }

    const NON_MARKING_AREAS = [
        "left_eye",
        "right_eye",
        "left_jaw",
        "right_jaw"
    ];

    selfie.init(tangentAssetsBase)
        .then(() => {

            // Keep all detections, only remove excluded areas
            const filteredItems = condition_msg_map.filter(
                item => !NON_MARKING_AREAS.includes(item.area)
            );

            if (!filteredItems.length) {
                toggle_loader_view(false);
                return;
            }
            // Highlight only that concern (all its regions)
            filteredItems
                .forEach(item => {
                    selfie.markFacialArea(
                        canvas,
                        item.area,
                        item.msg
                    );
                });

            selfie.setAreaClickCallback(
                canvas,
                selfieAreaClicked,
                true
            );

            toggle_loader_view(false);

        })
        .catch(error => {
            console.log("Error loading model:", error);

            toggle_loader_view(false);

            show_selfie_popupmessage(
                "Something went wrong, please check your internet connection!",
                "tangent-popup-msg"
            );
        });
}

function setTabOpen(tags = []) {
  const tabWrapper = document.querySelector("#tangent_sections_wrapper");
  const tabContents = document.querySelectorAll(".tabcontent");
  const tabButtons = document.querySelectorAll(".tablinks");

  if (!tabWrapper || !tabContents.length || !tabButtons.length) {
    return;
  }

  tabWrapper.style.display = "block";

  // Determine active tab index
  let activeIndex = 0;
  if (tags.includes("routine_10_mins")) activeIndex = 1;
  else if (!tags.includes("routine_5_mins")) activeIndex = 2;

  // Hide all tabs and deactivate buttons
  tabContents.forEach(tc => (tc.style.display = "none"));
  tabButtons.forEach(btn => btn.classList.remove("active"));

  // Safely activate the chosen tab if it exists
  if (tabContents[activeIndex] && tabButtons[activeIndex]) {
    tabContents[activeIndex].style.display = "block";
    tabButtons[activeIndex].classList.add("active");
  }
}

function createFormDataFromIds(idArray) {
  return {
    items: idArray.map(id => ({
      id: id,
      quantity: 1
    }))
  };
}

function addToCart(element){ 
  const formData = createFormDataFromIds([element.id]);
  addToCartApi(formData, element);
}

// Add all to cart function for sections
function addAllTocartFunction(element) {
  const formData = createFormDataFromIds(sections_add_to_cart_map[element.id].list);
  if(formData){
    addToCartApi(formData, element);
  } 
  else {
      var x = document.querySelector("#message-text");
      x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
      x.className = "show";
      setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
  }
}

function addToCartApi(payload, element){
  element.innerHTML = `<div class="loader button-loader">&nbsp;</div>`
  fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
  }).then(() => {
    element.innerHTML = default_addedToCartText;
    element.classList.add("added-to-cart-style"); 
  }).catch((error) => {
      console.error('Error:', error);
  });
}

// Main Section container 
function createSectionContainer(section_name) {
  const section_container = document.createElement("div");
  section_container.id = `${section_name}_container`;

  if (!TAB_EXCLUDED_SECTIONS.includes(section_name)) {
    section_container.classList.add("tabcontent");
  }

  section_container.classList.add(`${section_name}_container`);
  section_container.classList.add(`tangent-section-container`);
  return section_container;
}

function createSectionAddAllToCart(section_name) {
    const button = document.createElement("button");
    button.id = `${section_name}`;
    button.classList.add("section_add_all_to_cart","btn","btn--secondary", "btn--solid-border" ,"btn--small" ,"btn--advanced" ,"btn--submit" ,"product__submit__add" ,"btn--top", `${section_name}_add_all_to_cart`);
    button.innerHTML = default_add_all_to_cart_text;
    button.setAttribute("aria-label", `Add all ${section_name} items to cart`);
    button.addEventListener('click', () => addAllTocartFunction(button));
    return button;
}

// Container having individual products
function addSectionProductGridContainer(section_name) {
  const container = document.createElement("div");
  container.id = `${section_name}_product_grid`;
  container.classList.add("section_product_grid", `${section_name}_product_grid`);
  return container;
}

// Tab buttons 
function createTabButton(section_name) {
    const tab_button = document.createElement("button");
    tab_button.id = `${section_name}_tab_button`;
    tab_button.textContent = getTabTitle(section_name); // safer than innerHTML if text only
    tab_button.name = section_name;
    tab_button.classList.add("tablinks", `${section_name}_tab_button`);

    // Click listener
    tab_button.addEventListener("click", () => switchTab(tab_button));

    tangent_custom_tabs.appendChild(tab_button);
}

function getTabTitle(section) {
  // Use mapped title if available
  if (tabs_title_mapping && tabs_title_mapping[section] !== undefined) {
    return tabs_title_mapping[section];
  }

  // Fallback: clean up the section name
  return section
    .replace(/^section_/, "")  // Remove only prefix "section_"
    .replace(/_/g, " ")        // Replace ALL underscores with spaces
    .trim()
    .replace(/\b\w/g, c => c.toUpperCase()); // Capitalize each word
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    for (const section_name in product_sections) {
      // The created container will have both a container to show text and products
      var section_container = createSectionContainer(section_name);    
  
      // Creating text sections before products sections if exists
      if(text_sections!=undefined){
          createTextSectionBeforeProducts(text_sections,section_container,section_name);
      }    
      
      // Creating section to add all products
      section_container.appendChild(addSectionProductGridContainer(section_name));
  
      // Creating add all to cart button for the section    
      section_container.appendChild(createSectionAddAllToCart(section_name));

      // Add to main container wrapper
      tangent_sections_wrapper_element.appendChild(section_container);

      if (!TAB_EXCLUDED_SECTIONS.includes(section_name)) {
        createTabButton(section_name);
      }
    }
}

// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections, section_container, section_name) {
  const sectionText = text_sections[section_name];
  if (!sectionText) return;

  const section_div = document.createElement("div");
  section_div.id = `${section_name}_text_container`;
  section_div.classList.add("section_text_container", `${section_name}_text_container`);

  // Safely handle array or string input
  const content = Array.isArray(sectionText) ? sectionText.join(" ") : String(sectionText);
  section_div.innerHTML = content;

  // Insert text content at the TOP of the section (before product grid)
  section_container.insertBefore(section_div, section_container.firstChild);
}

function createTextSection(product_sections, text_sections, tags) {
  for (const section_name in text_sections) {
    // Skip if section already exists in product sections
    if (product_sections[section_name] !== undefined) continue;

    // Skip section_additional_product if tag is not present
    if (
      section_name === "section_additional_product" &&
      !tags.includes("tangent_selfie_dark_circles")
    ) {
      continue;
    }

    // Create the section container
    const section_container = createSectionContainer(section_name);

    // Create and append text container
    const container = document.createElement("div");
    container.id = `${section_name}_text_container`;
    container.classList.add("section_text_container", `${section_name}_text_container`);
    container.innerHTML = text_sections[section_name].join(" ");
    section_container.appendChild(container);

    // Special placement for selfie section
    if (section_name === "section_selfie") {
      const section_selfie = document.querySelector("#section_selfie_container_parent");
      section_container.classList.remove("tabcontent");
      section_selfie.appendChild(section_container);
    } else {
      tangent_sections_wrapper_element.appendChild(section_container);
    }
  }
}

function handleSelfieDisplay(data = {}) {
  const selfieUrl = data.selfie_original_url;

  const img = document.getElementById("selfie_img");
  const cover = document.getElementById("selfie_img_cover");
  const container = document.getElementById("tangent_selfie_div");

  if (selfieUrl) {
    if (img) img.src = selfieUrl;

    if (cover) cover.style.display = "none";

    if (container) container.style.display = "flex";

    if (typeof changeLoadingText === "function") {
      changeLoadingText("Scanning your selfie...");
    }
  } else {
    skip_selfie = true;
    setTangentDefaultSelfie();
  }
}

// Setting Selfie / Default Image
function setTangentDefaultSelfie() {
    const selfieImage = document.getElementById("selfie_img");
    if (tangent_default_selfie_image_url) {
        setElementDisplay("selfie_img", "flex");
        setElementDisplay("tangent_selfie_div", "flex");
        selfieImage.src = tangent_default_selfie_image_url;
    }
    else{
        setElementDisplay("tangent-img-container","none");
    }
}

function setElementDisplay(elementId, display) {
    const el = document.querySelector("#" + elementId);
    if (el) {
        el.style.display = display;
    }
}

// Handle tab button selection
function switchTab(element) {
    // Hide all tab contents
    document.querySelectorAll(".tabcontent").forEach(tab => {
        tab.style.display = "none";
    });

    // Remove active state from all tab buttons
    document.querySelectorAll(".tablinks").forEach(tab => {
        tab.classList.remove("active");
    });

    // Show selected tab content
    const content = document.getElementById(`${element.name}_container`);
    if (content) {
        content.style.display = "flex";
    }

    // Activate selected tab button
    const button = document.getElementById(`${element.name}_tab_button`);
    if (button) {
        button.classList.add("active");
    }
}

// Enabling button listeners
function enableButtonListener() {
    document.querySelectorAll('.tangent-product-add-btn-wrapper')
        .forEach(btn => {
            btn.addEventListener('click', function() {
                addToCart(this);
            });
        });
}

function loadElementsOnResponseData() {
  const allElements = document.querySelectorAll('.load-on-data');
  allElements.forEach(el => {
    el.style.display = el.dataset.originalDisplay || 'block';
  });
}

function hideLoading() {
  const loadingSection = document.querySelector("#loading-section");
  if (loadingSection) {
    loadingSection.style.display = "none";
  }
}

function setSelfieId(id) {
    tangent_selfie_id = id;
}

function getSelfieId() {
    return tangent_selfie_id;
}


function getSelectedVariant(product, variant_list) {
  const productVariants = product.variants.edges || [];
  
  if (productVariants.length === 0) {
    throw new Error("No variants available for the product.");
  }
  
  if (variant_list.length > 0) {
    const selectedVariantId = Number(variant_list[0]);
    return productVariants.find(variant => extractVariantId(variant.node.id) === selectedVariantId) || productVariants[0].node;
  }
  
  return productVariants[0].node;
}

const getVariantImage = (variant, product) => {
  if(variant.image?.url){
    return variant.image.url; 
  }
  else{
    return product.images.nodes[0].url
  }
  return 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
}

function isProductAvailable(product, variant){
  // Check if the product is active
  if (product.status !== "ACTIVE") {
      return false;
  }
  return variant.availableForSale;
}

function extractVariantId(variantId) {
  return variantId.replace("gid://shopify/ProductVariant/", "");
}


// Updating add all to cart object for sections
function updateSectionAllToCartLink(productSections, productId, variantId, sectionName, variant) {
    if (!productSections) return;

    Object.entries(productSections).forEach(([sectionKey, productIds]) => {
        if (!productIds.includes(String(productId))) return;

        const sectionData = sections_add_to_cart_map[sectionKey] ||= {
            count: 0,
            total: 0,
            cart_link: `${tangent_client_domain_url}/cart/add?`,
            list: []
        };

        if (sectionData.list.includes(variantId)) return;
        sectionData.count++;
        sectionData.list.push(variantId);
        sectionData.total += parseFloat(variant.price || 0);
        sectionData.cart_link += `&id[]=${variantId}`;
    });
}

function toggle_loader_view(flag) {
    const loaderEl = document.getElementById("tangent-selfie-loader");
    if (!loaderEl) {
        console.warn("Loader element #tangent-selfie-loader not found");
        return
    }
    loaderEl.style.display = flag ? "flex" : "none", loaderEl.setAttribute("aria-busy", flag ? "true" : "false")
}

function changeLoadingText(txt) {
    const loadingTextEl = document.getElementById("loading_text");
    if (!loadingTextEl) {
        console.warn("Loading text element #loading_text not found");
        return
    }
    loadingTextEl.textContent = String(txt ?? "")
}


function show_selfie_popupmessage(message, id) {
    const popup_element = document.getElementById(id);
    if (!popup_element) {
        console.warn(`Popup element #${id} not found`);
        return
    }
    popup_element.textContent = message ?? "";
    const container = selectElement("#tangent_selfie_div"),
        left = container ? container.offsetLeft : 0;
    Object.assign(popup_element.style, {
        top: "-95px",
        display: "block",
        maxWidth: "400px",
        border: "1px solid #cccccc",
        left: `${left}px`
    })
}

function getUniqueListBy(arr, key) {
    return [...new Map(arr.map(item => [item[key], item])).values()]
}

function checkForProduct() {
    condition_msg_map = [];
    const pdt_map = products_region_map["final_glass_skin"];
    if (!pdt_map || !final_selected_regions?.length) return;
    const NON_MARKING_PREFIXES = ["left_eye", "right_eye", "left_jaw", "right_jaw"],
        CONDITION_CONFIG = {
            acne: {
                key: "acne",
                text: "Try our <a href='https://scienceskincare.com.au/products/clear-calm-serum' target='_blank'>Clear + Calm Serum</a> to clear congested-looking skin and support smoother-looking pores"
            },
            wrinkles: {
                key: "wrinkles",
                text: "Try our <a href='https://scienceskincare.com.au/products/vitamin-a-serum' target='_blank'>Vitamin A 0.5% Serum</a> to soften fine lines and support smoother-looking skin overall"
            },
            rosacea: {
                key: "rosacea",
                text: "Try our <a href='https://scienceskincare.com.au/products/gel-cleanser' target='_blank'>Gel Cleanser</a> to gently cleanse reactive skin and support calmer-looking skin overall"
            },
            dark_spots: {
                key: "dark_spots",
                text: "Try our <a href='https://scienceskincare.com.au/products/enlighten-serum' target='_blank'>Enlighten Serum with Peptides</a> to target dark spots and support even-looking tone overall"
            },
            dark_circles: {
                key: "dark_circles",
                text: "Try our <a href='https://scienceskincare.com.au/products/peptide-eye-cream' target='_blank'>Eye Nourish + Peptides</a> to refresh tired eyes and soften visible dark circles"
            }
        };
    final_selected_regions.forEach(region => {
        const condition = Object.values(CONDITION_CONFIG)
            .find(cfg => region.startsWith(cfg.key + "_"));

        if (!condition) return;

        const area = region.replace(condition.key + "_", "");

        if (
            NON_MARKING_PREFIXES.some(prefix => area.includes(prefix)) &&
            condition.key !== "dark_circles"
        ) return;

        const productLink = `<a href="/products/" target="_blank">Product Name</a>`;

        condition_msg_map.push({
            area,
            key: condition.key,
            msg: `<p>
                ${condition.text}
            </p>`
        });
    });
}

function getProductUsingId(id) {
    return Array.isArray(tangentRecommendedProducts) && tangentRecommendedProducts.find(product => product.id == id) || null
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

class TangentSelfie {
    areasToMarkArray = [];
    FILL_COLOR = "rgba(255, 255, 255, 0.2)";
    STROKE_COLOR = "rgba(255, 255, 255, 0.6)";
    STROKE_HIGHLIGHT_COLOR = "rgba(255, 255, 255, 1)";
    UNDER_EYE_BAGS_HEIGHT = 15;
    CHIN_AREA_HEIGHT = 20;
    MOUTH_WRINKLES_WIDTH = 10;
    EYE_WRINKLE_MIN_WIDTH = 10;
    EYE_WRINKLE_MAX_WIDTH = 15;
    CHEEK_WIDTH_CUTOFF = 30;
    UNDER_EYE_BAGS_WIDTH_CUTTOFF = 20;
    CHEEK_MAX_WIDTH = 35;
    CHEEK_MAX_HEIGHT = 35;
    FOREHEAD_MAX_WIDTH = 55;
    FOREHEAD_MAX_HEIGHT = 30;
    constructor(imgId) {
        this.img = document.getElementById(imgId)
    }
    async init(assetsBaseUrl) {
        try {
            await this.imageLoad(this.img), await this.sleep(2e3);
            const options = new faceapi.SsdMobilenetv1Options({
                minConfidence: .2
            });
            await faceapi.loadSsdMobilenetv1Model(assetsBaseUrl), await faceapi.loadFaceLandmarkModel(assetsBaseUrl), this.faceLandmarks = await faceapi.detectSingleFace(this.img, options).withFaceLandmarks(), this.detection = this.faceLandmarks.detection
        } catch (e) {
            console.log(e)
        }
        if (!this.detection) throw new Error("Detection was not found")
    }
    async imageLoad(imgElem) {
        return new Promise(res => {
            if (imgElem.complete) return res();
            imgElem.onload = () => res(), imgElem.onerror = () => res()
        })
    }
    async sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms))
    }
    get imgWidth() {
        return this.detection.imageWidth
    }
    get imgHeight() {
        return this.detection.imageHeight
    }
    getAngleToFaceRightInRadians() {
        let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye(),
            rightEyePoints = this.faceLandmarks.landmarks.getRightEye();
        const theta = this.getAngleWithXAxisInRadians(leftEyePoints[0], rightEyePoints[0]);
        return theta < Math.PI / 2 ? theta : theta - Math.PI
    }
    getAngleToFaceLeftInRadians() {
        return this.getAngleToFaceRightInRadians() - Math.PI
    }
    getAngleToFaceDownInRadians() {
        return this.getAngleToFaceRightInRadians() + Math.PI / 2
    }
    getAngleToFaceUpInRadians() {
        return this.getAngleToFaceDownInRadians() - Math.PI
    }
    getLeftEyeHeight() {
        let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye();
        const h1 = this.getDistanceBetweenPoints(leftEyePoints[1], leftEyePoints[5]),
            h2 = this.getDistanceBetweenPoints(leftEyePoints[2], leftEyePoints[4]);
        return Math.max(h1, h2)
    }
    getLeftEyeWidth() {
        let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye();
        return this.getDistanceBetweenPoints(leftEyePoints[0], leftEyePoints[3])
    }
    getRightEyeHeight() {
        let rightEyePoints = this.faceLandmarks.landmarks.getRightEye();
        const h1 = this.getDistanceBetweenPoints(rightEyePoints[1], rightEyePoints[5]),
            h2 = this.getDistanceBetweenPoints(rightEyePoints[2], rightEyePoints[4]);
        return Math.max(h1, h2)
    }
    getLeftCrowFeetHeight() {
        let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye(),
            leftEyeBrowPoints = this.faceLandmarks.landmarks.getLeftEyeBrow();
        return this.getDistanceBetweenPoints(leftEyePoints[0], leftEyeBrowPoints[1])
    }
    getRightCrowFeetHeight() {
        let rightEyePoints = this.faceLandmarks.landmarks.getRightEye(),
            rightEyeBrowPoints = this.faceLandmarks.landmarks.getRightEyeBrow();
        return this.getDistanceBetweenPoints(rightEyePoints[3], rightEyeBrowPoints[3])
    }
    getRightEyeWidth() {
        let rightEyePoints = this.faceLandmarks.landmarks.getRightEye();
        return this.getDistanceBetweenPoints(rightEyePoints[0], rightEyePoints[3])
    }
    getLeftCrowFeetWidth() {
        let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye(),
            jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline();
        return Math.min(this.EYE_WRINKLE_MAX_WIDTH, this.getDistanceBetweenPoints(leftEyePoints[0], jawOutlinePoints[0]))
    }
    getRightCrowFeetWidth() {
        let rightEyePoints = this.faceLandmarks.landmarks.getRightEye(),
            jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline();
        return Math.min(this.EYE_WRINKLE_MAX_WIDTH, this.getDistanceBetweenPoints(rightEyePoints[3], jawOutlinePoints[16]))
    }
    getNoseWidth() {
        let nosePoints = this.faceLandmarks.landmarks.getNose();
        return this.getDistanceBetweenPoints(nosePoints[4], nosePoints[8])
    }
    getNoseHeight() {
        let nosePoints = this.faceLandmarks.landmarks.getNose();
        return this.getDistanceBetweenPoints(nosePoints[0], nosePoints[6])
    }
    getMouthWidth() {
        let mouthPoints = this.faceLandmarks.landmarks.getMouth();
        return this.getDistanceBetweenPoints(mouthPoints[0], mouthPoints[6])
    }
    getMouthHeight() {
        let mouthPoints = this.faceLandmarks.landmarks.getMouth();
        return this.getDistanceBetweenPoints(mouthPoints[3], mouthPoints[9])
    }
    getForeheadWidth() {
        let leftEyeBrowPoints = this.faceLandmarks.landmarks.getLeftEyeBrow(),
            rightEyeBrowPoints = this.faceLandmarks.landmarks.getRightEyeBrow();
        return this.getDistanceBetweenPoints(leftEyeBrowPoints[2], rightEyeBrowPoints[2])
    }
    getForeheadHeight() {
        let leftEyeBrowPoints = this.faceLandmarks.landmarks.getLeftEyeBrow(),
            rightEyeBrowPoints = this.faceLandmarks.landmarks.getRightEyeBrow(),
            faceTopPt = this.getToptMostPt(this.getFaceBounds());
        const h1 = leftEyeBrowPoints[2]._y - faceTopPt._y,
            h2 = rightEyeBrowPoints[2]._y - faceTopPt._y;
        return Math.min(h1, h2)
    }
    getLeftCheekWidth() {
        let jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline(),
            nosePoints = this.faceLandmarks.landmarks.getNose();
        return this.getDistanceBetweenPoints(jawOutlinePoints[3], nosePoints[4])
    }
    getRightCheekWidth() {
        let jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline(),
            nosePoints = this.faceLandmarks.landmarks.getNose();
        return this.getDistanceBetweenPoints(jawOutlinePoints[13], nosePoints[8])
    }
    getCheekHeight() {
        return this.getNoseHeight() - this.UNDER_EYE_BAGS_HEIGHT
    }
    getChinWidth() {
        let jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline();
        return this.getDistanceBetweenPoints(jawOutlinePoints[7], jawOutlinePoints[9])
    }
    getChinHeight() {
        return this.CHIN_AREA_HEIGHT
    }
    getFaceBounds() {
        const leftX = this.detection._box._x,
            rightX = this.detection._box._x + this.detection._box._width,
            topY = this.detection._box._y,
            bottomY = this.detection._box._y + this.detection._box._height;
        return [{
            _x: leftX,
            _y: topY
        }, {
            _x: rightX,
            _y: bottomY
        }]
    }
    getForeheadBounds() {
        let foreheadWidth = this.getForeheadWidth(),
            foreheadLeftRightPadding = 0;
        foreheadWidth > this.FOREHEAD_MAX_WIDTH && (foreheadLeftRightPadding = (foreheadWidth - this.FOREHEAD_MAX_WIDTH) / 2, foreheadWidth = this.FOREHEAD_MAX_WIDTH);
        let foreheadHeight = this.getForeheadHeight(),
            foreheadTopBottomPadding = 0;
        foreheadHeight > this.FOREHEAD_MAX_HEIGHT && (foreheadTopBottomPadding = (foreheadHeight - this.FOREHEAD_MAX_HEIGHT) / 2, foreheadHeight = this.FOREHEAD_MAX_HEIGHT);
        const leftBrowPt = this.faceLandmarks.landmarks.getLeftEyeBrow()[2],
            leftPaddingPt = this.getPointAtDistanceAndAngle(leftBrowPt, foreheadLeftRightPadding, this.getAngleToFaceRightInRadians()),
            leftBottomPt = this.getPointAtDistanceAndAngle(leftPaddingPt, foreheadTopBottomPadding, this.getAngleToFaceUpInRadians()),
            rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, foreheadWidth, this.getAngleToFaceRightInRadians()),
            leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, foreheadHeight, this.getAngleToFaceUpInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, foreheadHeight, this.getAngleToFaceUpInRadians());
        return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
    }
    getLeftUnderEyeBounds() {
        let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye();
        const leftTopPt = this.getPointAtDistanceAndAngle(leftEyePoints[0], this.getLeftEyeHeight() / 2, this.getAngleToFaceDownInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(leftTopPt, this.getLeftEyeWidth(), this.getAngleToFaceRightInRadians()),
            leftBottomPt = this.getPointAtDistanceAndAngle(leftTopPt, this.UNDER_EYE_BAGS_HEIGHT, this.getAngleToFaceDownInRadians()),
            rightBottomPt = this.getPointAtDistanceAndAngle(rightTopPt, this.UNDER_EYE_BAGS_HEIGHT, this.getAngleToFaceDownInRadians());
        return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
    }
    getRightUnderEyeBounds() {
        let rightEyePoints = this.faceLandmarks.landmarks.getRightEye();
        const leftTopPt = this.getPointAtDistanceAndAngle(rightEyePoints[0], this.getRightEyeHeight() / 2, this.getAngleToFaceDownInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(leftTopPt, this.getRightEyeWidth(), this.getAngleToFaceRightInRadians()),
            leftBottomPt = this.getPointAtDistanceAndAngle(leftTopPt, this.UNDER_EYE_BAGS_HEIGHT, this.getAngleToFaceDownInRadians()),
            rightBottomPt = this.getPointAtDistanceAndAngle(rightTopPt, this.UNDER_EYE_BAGS_HEIGHT, this.getAngleToFaceDownInRadians());
        return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
    }
    getLeftCrowFeetBounds() {
        let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye();
        const rightBottomPt = this.getPointAtDistanceAndAngle(leftEyePoints[0], this.getLeftCrowFeetHeight() / 2, this.getAngleToFaceDownInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(leftEyePoints[0], this.getLeftCrowFeetHeight() / 2, this.getAngleToFaceUpInRadians()),
            leftBottomPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.getLeftCrowFeetWidth(), this.getAngleToFaceLeftInRadians());
        return [this.getPointAtDistanceAndAngle(rightTopPt, this.getLeftCrowFeetWidth(), this.getAngleToFaceLeftInRadians()), leftBottomPt, rightBottomPt, rightTopPt]
    }
    getRightCrowFeetBounds() {
        let rightEyePoints = this.faceLandmarks.landmarks.getRightEye();
        const leftTopPt = this.getPointAtDistanceAndAngle(rightEyePoints[3], this.getRightCrowFeetHeight() / 2, this.getAngleToFaceUpInRadians()),
            leftBottomPt = this.getPointAtDistanceAndAngle(rightEyePoints[3], this.getRightCrowFeetHeight() / 2, this.getAngleToFaceDownInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(leftTopPt, this.getRightCrowFeetWidth(), this.getAngleToFaceRightInRadians()),
            rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getRightCrowFeetWidth(), this.getAngleToFaceRightInRadians());
        return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
    }
    getNoseBounds() {
        const leftBottomPt = this.faceLandmarks.landmarks.getNose()[4],
            rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getNoseWidth(), this.getAngleToFaceRightInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.getNoseHeight(), this.getAngleToFaceUpInRadians());
        return [this.getPointAtDistanceAndAngle(leftBottomPt, this.getNoseHeight(), this.getAngleToFaceUpInRadians()), leftBottomPt, rightBottomPt, rightTopPt]
    }
    getLeftCheekBounds() {
        let cheekWidth = this.getLeftCheekWidth(),
            cheekLeftRightPadding = 0;
        cheekWidth > this.CHEEK_MAX_WIDTH && (cheekLeftRightPadding = (cheekWidth - this.CHEEK_MAX_WIDTH) / 2, cheekWidth = this.CHEEK_MAX_WIDTH);
        let cheekHeight = this.getCheekHeight(),
            cheekTopBottomPadding = 0;
        cheekHeight > this.CHEEK_MAX_HEIGHT && (cheekTopBottomPadding = (cheekHeight - this.CHEEK_MAX_HEIGHT) / 2, cheekHeight = this.CHEEK_MAX_HEIGHT);
        const leftJawPt = this.faceLandmarks.landmarks.getJawOutline()[3],
            leftPaddingPt = this.getPointAtDistanceAndAngle(leftJawPt, cheekLeftRightPadding, this.getAngleToFaceRightInRadians()),
            leftBottomPt = this.getPointAtDistanceAndAngle(leftPaddingPt, cheekTopBottomPadding, this.getAngleToFaceUpInRadians()),
            rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, cheekWidth, this.getAngleToFaceRightInRadians()),
            leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, cheekHeight, this.getAngleToFaceUpInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, cheekHeight, this.getAngleToFaceUpInRadians());
        return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
    }
    getRightCheekBounds() {
        let cheekWidth = this.getRightCheekWidth(),
            cheekLeftRightPadding = 0;
        cheekWidth > this.CHEEK_MAX_WIDTH && (cheekLeftRightPadding = (cheekWidth - this.CHEEK_MAX_WIDTH) / 2, cheekWidth = this.CHEEK_MAX_WIDTH);
        let cheekHeight = this.getCheekHeight(),
            cheekTopBottomPadding = 0;
        cheekHeight > this.CHEEK_MAX_HEIGHT && (cheekTopBottomPadding = (cheekHeight - this.CHEEK_MAX_HEIGHT) / 2, cheekHeight = this.CHEEK_MAX_HEIGHT);
        const rightJawPt = this.faceLandmarks.landmarks.getJawOutline()[13],
            rightPaddingPt = this.getPointAtDistanceAndAngle(rightJawPt, cheekLeftRightPadding, this.getAngleToFaceLeftInRadians()),
            rightBottomPt = this.getPointAtDistanceAndAngle(rightPaddingPt, cheekTopBottomPadding, this.getAngleToFaceUpInRadians()),
            leftBottomPt = this.getPointAtDistanceAndAngle(rightBottomPt, cheekWidth, this.getAngleToFaceLeftInRadians()),
            leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, cheekHeight, this.getAngleToFaceUpInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, cheekHeight, this.getAngleToFaceUpInRadians());
        return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
    }
    getChinBounds() {
        const leftBottomPt = this.faceLandmarks.landmarks.getJawOutline()[7],
            rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getChinWidth(), this.getAngleToFaceRightInRadians()),
            leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getChinHeight(), this.getAngleToFaceUpInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.getChinHeight(), this.getAngleToFaceUpInRadians());
        return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
    }
    getLeftMouthWrinkleBounds() {
        let mouthPoints = this.faceLandmarks.landmarks.getMouth();
        const rightBottomPt = this.getPointAtDistanceAndAngle(mouthPoints[0], this.getMouthHeight() / 2, this.getAngleToFaceDownInRadians()),
            leftBottomPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.MOUTH_WRINKLES_WIDTH, this.getAngleToFaceLeftInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.getMouthHeight(), this.getAngleToFaceUpInRadians());
        return [this.getPointAtDistanceAndAngle(leftBottomPt, this.getMouthHeight(), this.getAngleToFaceUpInRadians()), leftBottomPt, rightBottomPt, rightTopPt]
    }
    getRightMouthWrinkleBounds() {
        let mouthPoints = this.faceLandmarks.landmarks.getMouth();
        const leftBottomPt = this.getPointAtDistanceAndAngle(mouthPoints[6], this.getMouthHeight() / 2, this.getAngleToFaceDownInRadians()),
            rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.MOUTH_WRINKLES_WIDTH, this.getAngleToFaceRightInRadians()),
            rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.getMouthHeight(), this.getAngleToFaceUpInRadians());
        return [this.getPointAtDistanceAndAngle(leftBottomPt, this.getMouthHeight(), this.getAngleToFaceUpInRadians()), leftBottomPt, rightBottomPt, rightTopPt]
    }
    getDistanceBetweenPoints(p1, p2) {
        return Math.sqrt(Math.pow(p1._x - p2._x, 2) + Math.pow(p1._y - p2._y, 2))
    }
    getMidpointBetweenPoints(p1, p2) {
        return {
            _x: Math.abs((p1._x + p2._x) / 2),
            _y: Math.abs((p1._y + p2._y) / 2)
        }
    }
    getAngleWithXAxisInRadians(p1, p2) {
        let dy = p1._y - p2._y,
            dx = p1._x - p2._x,
            theta = Math.atan2(dy, dx);
        return theta < 0 && (theta += Math.PI), theta
    }
    getPointAtDistanceAndAngle(sourcePt, distance, angle) {
        return {
            _x: sourcePt._x + distance * Math.cos(angle),
            _y: sourcePt._y + distance * Math.sin(angle)
        }
    }
    getLeftMostPt(pointsArray) {
        let leftMost = null;
        for (let i = 0; i < pointsArray.length; i++)(leftMost == null || pointsArray[i]._x < leftMost._x) && (leftMost = pointsArray[i]);
        return leftMost
    }
    getRightMostPt(pointsArray) {
        let rightMost = null;
        for (let i = 0; i < pointsArray.length; i++)(rightMost == null || pointsArray[i]._x > rightMost._x) && (rightMost = pointsArray[i]);
        return rightMost
    }
    getToptMostPt(pointsArray) {
        let topMost = null;
        for (let i = 0; i < pointsArray.length; i++)(topMost == null || pointsArray[i]._y < topMost._y) && (topMost = pointsArray[i]);
        return topMost
    }
    isPointInsidePoligon(pt, points) {
        for (var x = pt._x, y = pt._y, inside = !1, i = 0, j = points.length - 1; i < points.length; j = i++) {
            var xi = points[i]._x,
                yi = points[i]._y,
                xj = points[j]._x,
                yj = points[j]._y,
                intersect = yi > y != yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
            intersect && (inside = !inside)
        }
        return inside
    }
    clearCanvas(canvas2) {
        const ctx = canvas2.getContext("2d");
        ctx.resetTransform(), ctx.clearRect(0, 0, canvas2.width, canvas2.height)
    }
    scaleCanvas(canvas2) {
        var ctx = canvas2.getContext("2d");
        ctx.resetTransform(), ctx.scale(canvas2.width / this.imgWidth, canvas2.height / this.imgHeight)
    }
    scaleUpPt(originalPt, canvas2) {
        const canvasWidth = canvas2.getBoundingClientRect().width,
            canvasHeight = canvas2.getBoundingClientRect().height;
        return {
            _x: canvasWidth * originalPt._x / this.imgWidth,
            _y: canvasHeight * originalPt._y / this.imgHeight
        }
    }
    scaleBackPt(scaledPt, canvas2) {
        const canvasWidth = canvas2.getBoundingClientRect().width,
            canvasHeight = canvas2.getBoundingClientRect().height;
        return {
            _x: this.imgWidth * scaledPt._x / canvasWidth,
            _y: this.imgHeight * scaledPt._y / canvasHeight
        }
    }
    applyCanvasStrokeColor(canvas2, color) {
        var ctx = canvas2.getContext("2d");
        ctx.strokeStyle = color
    }
    setStrokeColor(color) {
        this.STROKE_COLOR = color
    }
    setHighlightStrokeColor(color) {
        this.STROKE_HIGHLIGHT_COLOR = color
    }
    setAreaClickCallback(canvas2, callback, setFirstAutoClick = !1) {
        if (this.areaClickCallback = callback, setFirstAutoClick && this.areasToMarkArray.length > 0) {
            this.areasToMarkArray[0].clicked = !0, this.drawAllShapes(canvas2);
            const scaledPt = this.scaleUpPt(this.areasToMarkArray[0].points[0], canvas2);
            this.areaClickCallback(this.areasToMarkArray[0].area, this.areasToMarkArray[0].messageOnClick, scaledPt._x, scaledPt._y)
        }
    }
    appendAreaToArray(area, points, messageOnClick) {
        this.areasToMarkArray.push({
            area,
            points,
            messageOnClick
        })
    }
    markFacialArea(canvas2, area, messageOnClick) {
        let points = null;
        switch (area) {
            case "forehead":
                points = this.getForeheadBounds();
                break;
            case "left_eye_under":
                points = this.getLeftUnderEyeBounds();
                break;
            case "right_eye_under":
                points = this.getRightUnderEyeBounds();
                break;
            case "left_eye_corner":
                points = this.getLeftCrowFeetBounds();
                break;
            case "right_eye_corner":
                points = this.getRightCrowFeetBounds();
                break;
            case "nose":
                points = this.getNoseBounds();
                break;
            case "left_cheek":
                points = this.getLeftCheekBounds();
                break;
            case "right_cheek":
                points = this.getRightCheekBounds();
                break;
            case "left_lip_corner":
                points = this.getLeftMouthWrinkleBounds();
                break;
            case "right_lip_corner":
                points = this.getRightMouthWrinkleBounds();
                break;
            case "chin":
                points = this.getChinBounds();
                break
        }
        points != null && (this.appendAreaToArray(area, points, messageOnClick), this.drawAllShapes(canvas2))
    }
    drawAllShapes(canvas2) {
        this.clearCanvas(canvas2), this.applyCanvasStrokeColor(canvas2, this.STROKE_COLOR);
        for (let i = 0; i < this.areasToMarkArray.length; i++) {
            var isClicked = "clicked" in this.areasToMarkArray[i];
            this.drawSingleShape(canvas2, this.areasToMarkArray[i].area, this.areasToMarkArray[i].points, isClicked)
        }
        this.clickListener && canvas2.removeEventListener("click", this.clickListener, !0), this.clickListener = this.canvasClickListener.bind(this), canvas2.addEventListener("click", this.clickListener, !0)
    }
    drawSingleShape(canvas2, area, points, clicked) {
        switch (area) {
            case "forehead":
                this.drawForehead(canvas2, area, points, clicked);
                break;
            case "left_eye_under":
                this.drawUnderEyeBags(canvas2, area, points, clicked);
                break;
            case "right_eye_under":
                this.drawUnderEyeBags(canvas2, area, points, clicked);
                break;
            case "left_eye_corner":
                this.drawEyeWrinkles(canvas2, area, points, clicked);
                break;
            case "right_eye_corner":
                this.drawEyeWrinkles(canvas2, area, points, clicked);
                break;
            case "nose":
                this.drawNose(canvas2, area, points, clicked);
                break;
            case "left_cheek":
                this.drawCheeks(canvas2, area, points, clicked);
                break;
            case "right_cheek":
                this.drawCheeks(canvas2, area, points, clicked);
                break;
            case "left_lip_corner":
                this.drawMouthWrinkles(canvas2, area, points, clicked);
                break;
            case "right_lip_corner":
                this.drawMouthWrinkles(canvas2, area, points, clicked);
                break;
            case "chin":
                this.drawChin(canvas2, area, points, clicked);
                break
        }
    }
    getCursorPosition(canvas2, event) {
        const rect = canvas2.getBoundingClientRect(),
            x = event.clientX - rect.left,
            y = event.clientY - rect.top;
        return {
            _x: x,
            _y: y
        }
    }
    canvasClickListener(event) {
        let canvas2 = event.target || event.srcElement;
        const clickPt = this.getCursorPosition(canvas2, event);
        let shapeClickedIndex = -1;
        for (let i = 0; i < this.areasToMarkArray.length; i++) shapeClickedIndex == -1 && this.isPointInsidePoligon(this.scaleBackPt(clickPt, canvas2), this.areasToMarkArray[i].points) ? (shapeClickedIndex = i, this.areasToMarkArray[i].clicked = !0) : "clicked" in this.areasToMarkArray[i] && delete this.areasToMarkArray[i].clicked;
        this.drawAllShapes(canvas2), this.areaClickCallback && (shapeClickedIndex == -1 ? this.areaClickCallback(null, null, clickPt._x, clickPt._y) : this.areaClickCallback(this.areasToMarkArray[shapeClickedIndex].area, this.areasToMarkArray[shapeClickedIndex].messageOnClick, clickPt._x, clickPt._y))
    }
    drawForehead(canvas2, area, points, clicked) {
        this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked)
    }
    drawUnderEyeBags(canvas2, area, points, clicked) {
        area == "left_eye_under" && this.getLeftEyeWidth() > this.UNDER_EYE_BAGS_WIDTH_CUTTOFF && this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked), area == "right_eye_under" && this.getRightEyeWidth() > this.UNDER_EYE_BAGS_WIDTH_CUTTOFF && this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked)
    }
    drawNose(canvas2, area, points, clicked) {
        this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked)
    }
    drawCheeks(canvas2, area, points, clicked) {
        area == "left_cheek" && this.getLeftCheekWidth() > this.CHEEK_WIDTH_CUTOFF && this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked), area == "right_cheek" && this.getRightCheekWidth() > this.CHEEK_WIDTH_CUTOFF && this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked)
    }
    drawChin(canvas2, area, points, clicked) {
        this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked)
    }
    drawMouthWrinkles(canvas2, area, points, clicked) {
        area == "left_lip_corner" && this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked), area == "right_lip_corner" && this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked)
    }
    drawEyeWrinkles(canvas2, area, points, clicked) {
        area == "left_eye_corner" && this.getLeftCrowFeetWidth() > this.EYE_WRINKLE_MIN_WIDTH && this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked), area == "right_eye_corner" && this.getRightCrowFeetWidth() > this.EYE_WRINKLE_MIN_WIDTH && this.drawEllipseOnCanvas(canvas2, points, this.getAngleToFaceRightInRadians(), clicked)
    }
    drawDetections(canvas2) {
        this.scaleCanvas(canvas2), faceapi.draw.drawDetections(canvas2, this.detection)
    }
    drawLandmarks(canvas2) {
        this.scaleCanvas(canvas2), faceapi.draw.drawFaceLandmarks(canvas2, this.faceLandmarks)
    }
    drawPolygonOnCanvas(canvas2, points) {
        this.scaleCanvas(canvas2);
        var ctx = canvas2.getContext("2d");
        for (let i = 0; i < points.length - 1; i++) ctx.beginPath(), ctx.moveTo(points[i]._x, points[i]._y), ctx.lineTo(points[i + 1]._x, points[i + 1]._y), ctx.stroke();
        ctx.beginPath(), ctx.moveTo(points[points.length - 1]._x, points[points.length - 1]._y), ctx.lineTo(points[0]._x, points[0]._y), ctx.stroke()
    }
    drawRectangleOnCanvas(canvas2, rectanglePoints) {
        this.scaleCanvas(canvas2);
        var ctx = canvas2.getContext("2d");
        ctx.beginPath(), ctx.rect(rectanglePoints[0]._x, rectanglePoints[0]._y, rectanglePoints[1]._x - rectanglePoints[0]._x, rectanglePoints[1]._y - rectanglePoints[0]._y), ctx.stroke()
    }
    drawEllipseOnCanvas(canvas2, rectanglePoints, tiltInRadians = 0, clicked) {
        this.scaleCanvas(canvas2);
        let p1 = rectanglePoints[0],
            p2 = rectanglePoints[1],
            p3 = rectanglePoints[2],
            p4 = rectanglePoints[3],
            d1 = this.getDistanceBetweenPoints(p1, p2) / 2,
            d2 = this.getDistanceBetweenPoints(p1, p4) / 2,
            m = this.getMidpointBetweenPoints(p1, p3);
        var ctx = canvas2.getContext("2d");
        ctx.beginPath(), ctx.ellipse(m._x, m._y, d2, d1, tiltInRadians, 0, Math.PI * 2), clicked ? ctx.strokeStyle = this.STROKE_HIGHLIGHT_COLOR : ctx.strokeStyle = this.STROKE_COLOR, ctx.fillStyle = this.FILL_COLOR, ctx.fill(), ctx.stroke()
    }
}

function selfieAreaClicked(area, message, x, y) {
    const popup = document.getElementById("tangent-popup-msg");

    if (!area) {
        popup.style.display = "none";
        return;
    }

    popup.innerHTML = message;
    popup.style.display = "block";

    const OFFSET = 10;
    const popupWidth = popup.offsetWidth;
    const popupHeight = popup.offsetHeight;

    let left = x;
    let top = y;

    // Prevent overflow (right & bottom)
    if (left + popupWidth > window.innerWidth) {
        left = window.innerWidth - popupWidth - OFFSET;
    }

    if (top + popupHeight > window.innerHeight) {
        top = window.innerHeight - popupHeight - OFFSET;
    }

    // Prevent negative (optional safety)
    if (left < 0) left = OFFSET;
    if (top < 0) top = OFFSET;

    popup.style.left = `${left}px`;
    popup.style.top = `${top}px`;
}

const canvas = document.getElementById("selfie_canvas");
let selfie = new TangentSelfie("selfie_img");